import { useQuery } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

export interface WebsiteSection {
  id: string;
  sectionTypeId: string;
  version: number;
  displayName: string;
}

interface WebsiteSectionsResponse {
  sections: WebsiteSection[];
}

async function fetchWebsiteSections(websiteId: string) {
  const { data } = await axiosPrivate.get<WebsiteSectionsResponse>(
    `/v3/pharmacist/plus-websites/${websiteId}/versions/preview/sections`
  );
  return data;
}

export function useGetWebsiteSections({ websiteId }: { websiteId: string }) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['plus-website-sections', websiteId],
    queryFn: () => fetchWebsiteSections(websiteId),
    enabled: !!websiteId,
    meta: { errorMessage: 'Failed to load website sections' },
  });

  return {
    sections: data?.sections ?? [],
    isLoading,
    isError,
    error,
  };
}
